import { call, put, select } from 'redux-saga/effects';
import { selectors, withOffset } from '../../Stream';
import { isApiError, requestPuppy } from '@wix/da-http-client';
import { getSearchQuery } from '../selectors';
import { normalizeDeviations } from '../../redux/normalizr/helpers';
import { FetchType } from '../../Stream/base/types';
export function fakeResponse({ params }) {
    if (process.env.NODE_ENV !== 'production') {
        const { deviationsByType } = require('@wix/da-sample-data'); // eslint-disable-line global-require
        const { Chance } = require('chance'); // eslint-disable-line global-require
        if (window.doError) {
            return {
                error: 'invalid_request',
                error_description: 'Not logged in.',
                status: 'error'
            };
        }
        const { offset, limit } = params;
        const randomDeviations = new Chance().pickset(deviationsByType.image, limit);
        return {
            hasMore: offset + limit < deviationsByType.image.length,
            nextOffset: offset + limit,
            results: randomDeviations
        };
    }
}
function* fetch(url, params) {
    const response = yield call(requestPuppy, {
        method: 'get',
        url,
        params
    }, fakeResponse);
    return response;
}
function* handleDeviationStreamFetch(action) {
    const { streamId } = action;
    const { offset, limit, searchQuery } = yield select((state)=>({
            offset: withOffset.selectors.getNextOffset(state, streamId),
            limit: selectors.getItemsPerFetch(state, streamId),
            searchQuery: getSearchQuery(state)
        }));
    const params = {
        include_scraps: true,
        q: searchQuery || undefined,
        offset,
        limit
    };
    const response = yield call(fetch, 'deviation/search', params);
    // TODO: proper error handling
    if (!response || isApiError(response)) {
        yield put(withOffset.actions.fetchFailure({
            streamId,
            fetchType: FetchType.Next,
            errorMsg: 'Failed to fetch'
        }));
        return;
    }
    const { hasMore, results } = response;
    const normalized = results && normalizeDeviations(results);
    var _normalized_result, _normalized_entities;
    yield put(withOffset.actions.fetchSuccess({
        streamId,
        hasMore: results ? !!hasMore : false,
        items: (_normalized_result = normalized === null || normalized === void 0 ? void 0 : normalized.result) !== null && _normalized_result !== void 0 ? _normalized_result : [],
        entities: (_normalized_entities = normalized === null || normalized === void 0 ? void 0 : normalized.entities) !== null && _normalized_entities !== void 0 ? _normalized_entities : {}
    }));
}
export default handleDeviationStreamFetch;

//# sourceMappingURL=browseDeviationStreamFetch.js.map